export default {"src":"/_next/static/media/mth.a53c4a24.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};